import { RiskByElementGroupWidget } from '../widgets/RiskByElementGroupWidget'
import { RiskByHazardWidget } from '../widgets/RiskByHazardWidget'
import type {
  RiskProfileMetricOption,
  RiskProfileQueryParams,
} from '../../../types/riskProfile.types'

interface GroupChartsSectionProps {
  queryParams: RiskProfileQueryParams | null
  metricOption: RiskProfileMetricOption
}

export function GroupChartsSection({ queryParams, metricOption }: GroupChartsSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <RiskByElementGroupWidget queryParams={queryParams} metricOption={metricOption} />
      <RiskByHazardWidget queryParams={queryParams} metricOption={metricOption} />
    </div>
  )
}
